// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"f48a3e6a","59":"dde76ba5","78":"a8973df6","98":"9cf3081c","615":"d31283b9","899":"508b8d8c"}[chunkId] + ".chunk.css";
};